
































import Vue from "vue";
import Component from "vue-class-component";
import { TrackingOrder, Shipper } from "@/store";
import { Prop } from "vue-property-decorator";

@Component
export default class extends Vue {
    @Prop({ type: Object })
    trackingOrder!: TrackingOrder;

    @Prop({ type: Boolean, default: false })
    hideLineNumber!: boolean;

    fields: any[] = [
        { key: "lineNumber", sortable: true },
        { key: "quantity", sortable: true },
        { key: "partNumber", sortable: true },
        { key: "description", sortable: true },
        { key: "orderDate", sortable: true },
        { key: "estimatedShipDate", sortable: true },
        { key: "shipper", sortable: true },
    ];

    isLinkable(shipper: Shipper): boolean {
        return !!shipper.trackingOrderUrl && shipper.trackingOrderUrl.indexOf("{0}") > -1 && !!shipper.trackingNumber;
    }

    shipperTracking(url: string, trackingNumber: string): string {
        return url.replace("{0}", trackingNumber);
    }

    get showFields() {
        return this.fields.filter(f => f.key != "lineNumber" || !this.hideLineNumber);
    }

    customShipperModal() {
        this.$bvModal.msgBoxOk(
            `Tracking information not available for this shipment. Please contact ${this.trackingOrder.manufacturer?.name ??
                "the manufacturer"} for shipping information.`
        );
    }
}
